import { render, staticRenderFns } from "./GHGIComparison.vue?vue&type=template&id=5cf25f84"
import script from "./GHGIComparison.vue?vue&type=script&lang=js"
export * from "./GHGIComparison.vue?vue&type=script&lang=js"
import style0 from "./GHGIComparison.vue?vue&type=style&index=0&id=5cf25f84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports